import * as localeActionTypes from "ActionTypes/localeActionTypes";

const localeSetActions = (function() {
  const actions = {
    setMarkets: markets => {
      return {
        type: localeActionTypes.SET_MARKETS,
        markets
      };
    },
    setCountries: apiCountryData => {
      return {
        type: localeActionTypes.SET_COUNTRIES,
        apiCountryData
      };
    },
    setMarketCurrency: marketCurrency => {
      return {
        type: localeActionTypes.SET_MARKET_CURRENCY,
        marketCurrency
      };
    },
    setCountry: country => {
      return {
        type: localeActionTypes.SET_COUNTRY,
        country
      };
    },
    setState: state => {
      return {
        type: localeActionTypes.SET_STATE,
        state
      };
    },
    setLanguage: language => {
      return {
        type: localeActionTypes.SET_LANGUAGE,
        language
      };
    },
    //set the locale in store and localstorage, en-US format
    setLocale: locale => {
      return {
        type: localeActionTypes.SET_LOCALE,
        locale
      };
    },
    setTranslations: translations => {
      return {
        type: localeActionTypes.SET_TRANSLATIONS,
        translations: translations
      };
    },
    setLangOptions: langOptions => {
      return {
        type: localeActionTypes.SET_LANG_OPTIONS,
        langOptions
      };
    },
    setFeatureFlags: featureFlags => {
      return {
        type: localeActionTypes.SET_FEATURE_FLAGS,
        featureFlags: featureFlags
      };
    },
    setRegions: regions => {
      return {
        type: localeActionTypes.SET_REGIONS,
        regions
      };
    },
    setBillingRegions: (billing_regions) => {
      return {
        type: localeActionTypes.SET_BILLING_REGIONS,
        billing_regions
      };
    },
    setShippingMethods: (shippingMethods) => {
      return {
        type: localeActionTypes.SET_SHIPPING_METHODS,
        shippingMethods
      };
    },
    setFilteredShippingMethods: (filteredShippingMethods) => {
      return {
        type: localeActionTypes.SET_FILTERED_SHIPPING_METHODS,
        filteredShippingMethods
      };
    },
    setPreLoaded: preloaded => {
      return {
        type: localeActionTypes.SET_PRELOADED,
        preloaded
      };
    },
  };
  return actions;
})();

export default localeSetActions;



// WEBPACK FOOTER //
// ./src/store/actions/localeActions/localeSetActions.js